/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 * ======================================================================== */

export default class Calculator{
  constructor(options) {
    this.options = options;

    // this.options.gold_rachat = 35;
  }

  launch( type, amout, precision, gold ){

      if( type == 'buy' ){
        return this.buy(amout, gold);
      } else{
        return this.sale(amout, precision);
      }

  }

  buy(amout, gold){
    amout = parseFloat( amout );
    amout = isNaN( amout ) ? 0 : amout;

    var gold_buy = parseFloat( gold ) + 150; // Gold price for 1KG
    var percentage = parseFloat(amout) * 100 / gold_buy;

    console.log( this.options.gold_buy );

    return (1000 / 100) * percentage;
  }

  sale(amout, precision){

    amout = parseFloat( amout );
    amout = isNaN( amout ) ? 0 : amout;

    var carats = {
      'carat24': 1,
      'carat21': 0.87,
      'carat18': 0.72,
      'carat14': 0.55,
      'carat9': 0.33,
      'carat8': 0.31,
    };

    // poids x coefficient x prix que l’on rachète (ajd’hui 30€ gr d’or pur)
    var price = amout * carats['carat' + precision] * this.options.gold_rachat;

    return price;
  }

}



// WEBPACK FOOTER //
// ./scripts/util/Calculator.js